import { Hook } from "@oclif/core"
import * as Sentry from "@sentry/node"

import { VaultService } from "../../services/index.js"
import { getTargetEnv } from "../../types/index.js"

const hook: Hook<"prerun"> = async function (opts) {
  const span = Sentry.getActiveSpan()
  if (span) {
    span.setAttribute("command", opts.Command.id)
    span.updateName(opts.Command.id)
    const vaultService = new VaultService()
    const user = await vaultService.getLoggedInUserSub(getTargetEnv())
    if (user) {
      Sentry.setUser({ id: user })
      span.setAttribute("user", user)
    }
  }
}

export default hook
